import { render, staticRenderFns } from "./PlatformFundFlowStatements.vue?vue&type=template&id=5320f3b4&scoped=true&"
import script from "./PlatformFundFlowStatements.vue?vue&type=script&lang=js&"
export * from "./PlatformFundFlowStatements.vue?vue&type=script&lang=js&"
import style0 from "./PlatformFundFlowStatements.vue?vue&type=style&index=0&id=5320f3b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5320f3b4",
  null
  
)

export default component.exports